export default {
  not_localised: 'Este documento aún no está disponible en tu región. Mostrando la versión en inglés.',
};
